
import React from 'react';
import { useUserProgress } from '@/hooks/useUserProgress';
import { useNodes } from '@/hooks/useNodes';
import { useAuth } from '@/hooks/useAuth';
import LearningRecommendations from './LearningRecommendations';
import LearningInsights from './LearningInsights';
import { NodeWithDiscipline } from './types';

interface AdaptiveLearningProps {
  currentNodeId?: string;
  disciplineId?: string;
}

const AdaptiveLearning: React.FC<AdaptiveLearningProps> = ({ 
  currentNodeId,
  disciplineId 
}) => {
  const { user } = useAuth();
  const { data: progressData } = useUserProgress();
  const { data: allNodes } = useNodes();

  if (!user || !progressData || !allNodes) {
    return null;
  }

  // Type assertion to match our expected type structure
  const typedNodes = allNodes as NodeWithDiscipline[];

  // Get completed and in-progress nodes
  const completedNodes = progressData.filter(p => p.status === 'completed').map(p => p.node_id);
  const inProgressNodes = progressData.filter(p => p.status === 'in_progress').map(p => p.node_id);
  const viewedNodes = progressData.filter(p => p.status === 'viewed').map(p => p.node_id);

  // Get recently completed nodes for related suggestions
  const recentlyCompleted = progressData
    .filter(p => p.status === 'completed' && p.completed_at)
    .sort((a, b) => new Date(b.completed_at!).getTime() - new Date(a.completed_at!).getTime())
    .slice(0, 3);

  return (
    <div className="space-y-6">
      <LearningRecommendations
        completedNodes={completedNodes}
        inProgressNodes={inProgressNodes}
        viewedNodes={viewedNodes}
        recentlyCompleted={recentlyCompleted}
        allNodes={typedNodes}
        currentNodeId={currentNodeId}
      />

      <LearningInsights
        completedNodes={completedNodes}
        inProgressNodes={inProgressNodes}
        recentlyCompleted={recentlyCompleted}
        allNodes={typedNodes}
      />
    </div>
  );
};

export default AdaptiveLearning;
